'use client'

import React from "react";
import { UserContextProvider } from "./useUserContext";
import { NotificationProvider } from "@/components/PushNotification/NotificationProvider";
import { ChatProvider } from "@/components/Chat/ChatProvider";
import { AdminSupportChatProvider } from "@/components/Chat/AdminSupportChatProvider";
import { PhoneProvider } from "@/components/Admin/Phone/PhoneProvider";

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
      <UserContextProvider>
        <NotificationProvider>
          <AdminSupportChatProvider>
            <ChatProvider>
              <PhoneProvider>
                {children}
              </PhoneProvider>
            </ChatProvider>
          </AdminSupportChatProvider>
        </NotificationProvider>
      </UserContextProvider>
  );
};
